require('./payrollLoanRequestUpload.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const get = require('lodash/object/get');
// @constants
const {
    uploadFile,
    MAX_LENGTH_TITLE_UPLOAD_COMPONENT,
    FILE_TYPES,
    payrollLoanTypeUpload: {
        IRPF_FILE,
        PAYROLL_LOAN_CERTIFICATE,
        ADITIONAL_EXPENSES_FILES
    }
} = require('../../../../../loansConstants/index');

// @ commons
const { OKFileUpload } = require('commonsComponents/OKFileUpload');

// @ helpers
const { hasTranslation, formatText, FormattedText } = require('core/i18n').i18n;

//@utilities
const { haveExpenses } = require('../../../../../loansUtilities/loansHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @Contact Center
const PayrollLoanUploadStatus = require('../../../../contactCenter/payrollLoanUploadStatus/payrollLoanUploadStatus');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');

// @ constants
const { ONLY_LETTERS_ACCENTS_NUMBERS_SPACES_GUIDES_REGEX } = require('constants/index');

class PayrollLoanRequestUpload extends React.Component {
    getInvalidMessage() {
        return formatText('payrollLoanDocumentsUpload-errorInUploadedDocument');
    }

    validateFileObject(immRequest) {
        let response;
        if (!!immRequest.get('file') && (immRequest.getIn(['file', 'name']) || immRequest.get('file').name)) {
            response = immRequest.get('file')
        }
        return response;
    }

    buildCCUpload(immFile, fileDescription) {
        const invalidMessage = this.getInvalidMessage();
        const error = immFile.get('error');
        const invalid = immFile.get('notValid');

        const errorOrInvalid = error !== '' || invalid;
        const errorMessage = invalid ? invalidMessage : error;
        const file = this.validateFileObject(immFile);

        return (
            <PayrollLoanUploadStatus
                customFileDescription={fileDescription}
                error={errorOrInvalid}
                errorMessage={errorMessage}
                file={file}
            />
        )
    }

    buildDragNDropComponent(immFile, typeFile, props) {
        const { clearErrorsFile, loadFileInUpload, removeUploadedFile } = this.props;
        const idx = immFile.get('idx');
        const documentId = immFile.get('documentId');
        const invalid = immFile.get('notValid');
        const error = immFile.get('error') !== '' || !!invalid;
        const invalidMessage = this.getInvalidMessage();
        const errorMessageFromImm = hasTranslation(immFile.get('error')) ? formatText(immFile.get('error')) : immFile.get('error');
        const errorMessage = invalid ? invalidMessage : errorMessageFromImm;

        const fileUploadProps = {
            ...props,
            disabled: immFile.get('isFetching'),
            documentId,
            error,
            errorMessage,
            file: this.validateFileObject(immFile),
            idx,
            invalid,
            invalidCloseButton: true,
            loading: immFile.get('isFetching'),
            newFileName: immFile.get('newName'),
            valid: !invalid,
            texts: {
                editFileName: formatText('payrollLoanRequestStepThree-payrollLoanRequestStepThree_editFileName'),
                editReturn: <FormattedText value="payrollLoanRequestStepThree-payrollLoanRequestStepThree_pressEnterToSave" />,
                errorSize: formatText('payrollLoanRequestStepThree-uploadSizeError', [uploadFile.MAX_SIZE_FILE]),
                errorType: formatText('payrollLoanRequestStepThree-uploadTypeError', [FILE_TYPES.join(', ')]),
                errorTypeSize: formatText('payrollLoanRequestStepThree-payrollLoanRequestStepThree_uploadTypeAndSizeError'),
                supportedFormats: formatText('dragNDropUpload-supportedFormats', [FILE_TYPES.join(', ').toUpperCase()]),
                uploadSuccess: formatText('payrollLoanRequestStepThree-payrollLoanRequestStepThree_uploadFileSuccess'),
                uploadText: formatText('dragNDropUpload-defaultDescription'),
                uploadLink: formatText('dragNDropUpload-defaultDescriptionSelectFile')
            },
            handlers: {
                ...get(props, 'handlers'),
                change: fileState => loadFileInUpload(typeFile, get(fileState, 'file'), idx),
                removeFile: () => removeUploadedFile(typeFile, idx, documentId),
                clearErrors: () => clearErrorsFile(typeFile, idx, documentId)
            }
        };

        return (
            <OKFileUpload
                {...fileUploadProps}
                allowFileNameRegexp={ONLY_LETTERS_ACCENTS_NUMBERS_SPACES_GUIDES_REGEX}
                titleLength={uploadFile.NAME_LENGTH}
                maxSize={uploadFile.MAX_SIZE_FILE}
                hideFormats
                hideSizeLimit
                maxLengthTitleUpload={MAX_LENGTH_TITLE_UPLOAD_COMPONENT}
                validTypesFile={FILE_TYPES}
            />
        );
    }

    buildUploadFileAditionalExpenses() {
        const {
            immPayrollLoanRequest,
            handlerEditFileName
        } = this.props;
        const immUpload = immPayrollLoanRequest.get('upload');
        const immFiles = immUpload.get(ADITIONAL_EXPENSES_FILES);

        const files = immFiles.get('files');
        const hideExpenses = !haveExpenses(immPayrollLoanRequest.get('outcome')) && __CONTACT_CENTER__;
        const fileDescription = formatText('payrollLoanDocumentsUpload-payrollLoanDocumentsUpload_expensesFileDescription');

        return files.map((immFile) => {
            let contactCenterContent;
            const idx = immFile.get('idx');
            const documentId = immFile.get('documentId');
            const uploadExpensesComponent = this.buildDragNDropComponent(immFile, ADITIONAL_EXPENSES_FILES, {
                fileDescription,
                idName: 'fileAditionalExpenses',
                handlers: {
                    editFileName: (nameFile) => handlerEditFileName(ADITIONAL_EXPENSES_FILES, nameFile, idx, documentId)
                }
            });

            if (isPrintOfficeMode()) {
                contactCenterContent = uploadExpensesComponent;
            } else if (hideExpenses) {
                contactCenterContent = null;
            } else if (files.size === 1 || documentId) {
                contactCenterContent = this.buildCCUpload(immFile, fileDescription);
            }

            return (
                <div key={idx} className="payroll-loan-request-upload__container-drag-n-drop col-md-4">
                    <WebappRender>
                        {uploadExpensesComponent}
                    </WebappRender>
                    <ContactCenterRender>
                        {contactCenterContent}
                    </ContactCenterRender>
                </div>
            );
        });
    }

    buildUploadFilePayrollLoanCertificate() {
        const {
            immPayrollLoanRequest
        } = this.props;
        const immUpload = immPayrollLoanRequest.get('upload');
        const immFile = immUpload.get(PAYROLL_LOAN_CERTIFICATE);

        const fileDescription = formatText('payrollLoanDocumentsUpload-payrollLoanFileDescription');
        const dragNDrop = this.buildDragNDropComponent(immFile, PAYROLL_LOAN_CERTIFICATE, {
            fileDescription,
            idName: 'certificadoFile',
        });

        const contactCenterContent = isPrintOfficeMode() ? dragNDrop : this.buildCCUpload(immFile, fileDescription);

        return (

            <div className="payroll-loan-request-upload__container-drag-n-drop col-md-4">
                <WebappRender>
                    {dragNDrop}
                </WebappRender>
                <ContactCenterRender>
                    {contactCenterContent}
                </ContactCenterRender>
            </div>
        );
    }

    buildUploadFileIrpfComponent() {
        const { immPayrollLoanRequest } = this.props;
        const immUpload = immPayrollLoanRequest.get('upload');
        const immFile = immUpload.get(IRPF_FILE);
        const fileDescription = formatText('payrollLoanDocumentsUpload-payrollLoanDocumentsUpload_irpfFileDescription');

        const dragNDrop = this.buildDragNDropComponent(immFile, IRPF_FILE, {
            fileDescription,
            idName: 'irpfFile'
        });

        const contactCenterContent = isPrintOfficeMode() ? dragNDrop : this.buildCCUpload(immFile, fileDescription);

        return (
            <div className=" payroll-loan-request-upload__container-drag-n-drop col-md-4">
                <WebappRender>
                    {dragNDrop}
                </WebappRender>
                <ContactCenterRender>
                    {contactCenterContent}
                </ContactCenterRender>
            </div>
        );
    }

    render() {
        const payrollLoanCertificateComponent = this.buildUploadFilePayrollLoanCertificate();
        const irpfComponent = this.buildUploadFileIrpfComponent();
        const aditionalExpenses = this.buildUploadFileAditionalExpenses();

        return (
            <div>
                <div className="row">
                    {payrollLoanCertificateComponent}
                    {irpfComponent}
                    {aditionalExpenses}
                </div>
            </div>
        );
    }
}

PayrollLoanRequestUpload.propTypes = {
    handlerEditFileName: PropTypes.func.isRequired,
    immPayrollLoanRequest: PropTypes.object.isRequired,
    loadFileInUpload: PropTypes.func.isRequired,
    recordStatus: PropTypes.string.isRequired,
    removeUploadedFile: PropTypes.func.isRequired,
    clearErrorsFile: PropTypes.func.isRequired
};

module.exports = PayrollLoanRequestUpload;
